export default __webpack_public_path__ + "static/media/27.f393e5b0.jpg";